import { get } from '../utils/http';

export function getPosts() {
	return get('/posts?status=publish&categories=169');
}
